import { IThunkActionCreator } from '../../types/redux';
import { IRequestCallbackInterface, IRequestCallbackResultInterface } from '@cian/callback-widget/lib/shared/utils/api';
import { sendCallback } from '../../services/sendCallbackInfo/sendCallbackInfo';

export function sendCallbackInfo(
  query: IRequestCallbackInterface,
): IThunkActionCreator<Promise<IRequestCallbackResultInterface>> {
  //@ts-ignore
  return async (dispatch, getState, { httpApi }) => sendCallback(httpApi, query);
}
